/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAddTicketRouteImport } from './routes/_app/add-ticket'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppPlanRouteImport } from './routes/_app/plan'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppTicketsRouteImport } from './routes/_app/tickets'
import { Route as AuthOtpRouteImport } from './routes/auth/otp'
import { Route as AuthPhoneRouteImport } from './routes/auth/phone'
import { Route as AppExploreIndexRouteImport } from './routes/_app/explore/index'
import { Route as AppPlacesIdOrSlugRouteImport } from './routes/_app/places/$idOrSlug'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppProfileNotificationsRouteImport } from './routes/_app/profile/notifications'
import { Route as AppProfilePassportRouteImport } from './routes/_app/profile/passport'
import { Route as AppProfileReviewsRouteImport } from './routes/_app/profile/reviews'
import { Route as AppSegmentsSegmentIdRouteImport } from './routes/_app/segments/$segmentId'
import { Route as AppTripsIndexRouteImport } from './routes/_app/trips/index'
import { Route as AppTripsTripIdRouteImport } from './routes/_app/trips/$tripId'
import { Route as AppExploreCitiesSlugRouteImport } from './routes/_app/explore/cities/$slug'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAddTicketRoute = AppAddTicketRouteImport.update({
  id: '/add-ticket',
  path: '/add-ticket',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanRoute = AppPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRoute = AppTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRoute,
} as any)
const AuthOtpRoute = AuthOtpRouteImport.update({
  id: '/auth/otp',
  path: '/auth/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthPhoneRoute = AuthPhoneRouteImport.update({
  id: '/auth/phone',
  path: '/auth/phone',
  getParentRoute: () => rootRouteImport,
} as any)
const AppExploreIndexRoute = AppExploreIndexRouteImport.update({
  id: '/explore/',
  path: '/explore/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlacesIdOrSlugRoute = AppPlacesIdOrSlugRouteImport.update({
  id: '/places/$idOrSlug',
  path: '/places/$idOrSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileNotificationsRoute = AppProfileNotificationsRouteImport.update({
  id: '/profile/notifications',
  path: '/profile/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppProfilePassportRoute = AppProfilePassportRouteImport.update({
  id: '/profile/passport',
  path: '/profile/passport',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileReviewsRoute = AppProfileReviewsRouteImport.update({
  id: '/profile/reviews',
  path: '/profile/reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppSegmentsSegmentIdRoute = AppSegmentsSegmentIdRouteImport.update({
  id: '/segments/$segmentId',
  path: '/segments/$segmentId',
  getParentRoute: () => AppRoute,
} as any)
const AppTripsIndexRoute = AppTripsIndexRouteImport.update({
  id: '/trips/',
  path: '/trips/',
  getParentRoute: () => AppRoute,
} as any)
const AppTripsTripIdRoute = AppTripsTripIdRouteImport.update({
  id: '/trips/$tripId',
  path: '/trips/$tripId',
  getParentRoute: () => AppRoute,
} as any)
const AppExploreCitiesSlugRoute = AppExploreCitiesSlugRouteImport.update({
  id: '/explore/cities/$slug',
  path: '/explore/cities/$slug',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/onboarding': typeof OnboardingRoute
  '/add-ticket': typeof AppAddTicketRoute
  '/notifications': typeof AppNotificationsRoute
  '/plan': typeof AppPlanRoute
  '/search': typeof AppSearchRoute
  '/tickets': typeof AppTicketsRoute
  '/auth/otp': typeof AuthOtpRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/places/$idOrSlug': typeof AppPlacesIdOrSlugRoute
  '/profile/notifications': typeof AppProfileNotificationsRoute
  '/profile/passport': typeof AppProfilePassportRoute
  '/profile/reviews': typeof AppProfileReviewsRoute
  '/segments/$segmentId': typeof AppSegmentsSegmentIdRoute
  '/trips/$tripId': typeof AppTripsTripIdRoute
  '/explore/': typeof AppExploreIndexRoute
  '/profile/': typeof AppProfileIndexRoute
  '/trips/': typeof AppTripsIndexRoute
  '/explore/cities/$slug': typeof AppExploreCitiesSlugRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRoute
  '/add-ticket': typeof AppAddTicketRoute
  '/notifications': typeof AppNotificationsRoute
  '/plan': typeof AppPlanRoute
  '/search': typeof AppSearchRoute
  '/tickets': typeof AppTicketsRoute
  '/auth/otp': typeof AuthOtpRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/': typeof AppIndexRoute
  '/places/$idOrSlug': typeof AppPlacesIdOrSlugRoute
  '/profile/notifications': typeof AppProfileNotificationsRoute
  '/profile/passport': typeof AppProfilePassportRoute
  '/profile/reviews': typeof AppProfileReviewsRoute
  '/segments/$segmentId': typeof AppSegmentsSegmentIdRoute
  '/trips/$tripId': typeof AppTripsTripIdRoute
  '/explore': typeof AppExploreIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/trips': typeof AppTripsIndexRoute
  '/explore/cities/$slug': typeof AppExploreCitiesSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/_app/add-ticket': typeof AppAddTicketRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/plan': typeof AppPlanRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/tickets': typeof AppTicketsRoute
  '/auth/otp': typeof AuthOtpRoute
  '/auth/phone': typeof AuthPhoneRoute
  '/_app/': typeof AppIndexRoute
  '/_app/places/$idOrSlug': typeof AppPlacesIdOrSlugRoute
  '/_app/profile/notifications': typeof AppProfileNotificationsRoute
  '/_app/profile/passport': typeof AppProfilePassportRoute
  '/_app/profile/reviews': typeof AppProfileReviewsRoute
  '/_app/segments/$segmentId': typeof AppSegmentsSegmentIdRoute
  '/_app/trips/$tripId': typeof AppTripsTripIdRoute
  '/_app/explore/': typeof AppExploreIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/trips/': typeof AppTripsIndexRoute
  '/_app/explore/cities/$slug': typeof AppExploreCitiesSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/add-ticket'
    | '/notifications'
    | '/plan'
    | '/search'
    | '/tickets'
    | '/auth/otp'
    | '/auth/phone'
    | '/places/$idOrSlug'
    | '/profile/notifications'
    | '/profile/passport'
    | '/profile/reviews'
    | '/segments/$segmentId'
    | '/trips/$tripId'
    | '/explore/'
    | '/profile/'
    | '/trips/'
    | '/explore/cities/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/add-ticket'
    | '/notifications'
    | '/plan'
    | '/search'
    | '/tickets'
    | '/auth/otp'
    | '/auth/phone'
    | '/'
    | '/places/$idOrSlug'
    | '/profile/notifications'
    | '/profile/passport'
    | '/profile/reviews'
    | '/segments/$segmentId'
    | '/trips/$tripId'
    | '/explore'
    | '/profile'
    | '/trips'
    | '/explore/cities/$slug'
  id:
    | '__root__'
    | '/_app'
    | '/onboarding'
    | '/_app/add-ticket'
    | '/_app/notifications'
    | '/_app/plan'
    | '/_app/search'
    | '/_app/tickets'
    | '/auth/otp'
    | '/auth/phone'
    | '/_app/'
    | '/_app/places/$idOrSlug'
    | '/_app/profile/notifications'
    | '/_app/profile/passport'
    | '/_app/profile/reviews'
    | '/_app/segments/$segmentId'
    | '/_app/trips/$tripId'
    | '/_app/explore/'
    | '/_app/profile/'
    | '/_app/trips/'
    | '/_app/explore/cities/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  AuthOtpRoute: typeof AuthOtpRoute
  AuthPhoneRoute: typeof AuthPhoneRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/add-ticket': {
      id: '/_app/add-ticket'
      path: '/add-ticket'
      fullPath: '/add-ticket'
      preLoaderRoute: typeof AppAddTicketRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plan': {
      id: '/_app/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof AppPlanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/otp': {
      id: '/auth/otp'
      path: '/auth/otp'
      fullPath: '/auth/otp'
      preLoaderRoute: typeof AuthOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/phone': {
      id: '/auth/phone'
      path: '/auth/phone'
      fullPath: '/auth/phone'
      preLoaderRoute: typeof AuthPhoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/explore/': {
      id: '/_app/explore/'
      path: '/explore'
      fullPath: '/explore/'
      preLoaderRoute: typeof AppExploreIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/places/$idOrSlug': {
      id: '/_app/places/$idOrSlug'
      path: '/places/$idOrSlug'
      fullPath: '/places/$idOrSlug'
      preLoaderRoute: typeof AppPlacesIdOrSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/notifications': {
      id: '/_app/profile/notifications'
      path: '/profile/notifications'
      fullPath: '/profile/notifications'
      preLoaderRoute: typeof AppProfileNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/passport': {
      id: '/_app/profile/passport'
      path: '/profile/passport'
      fullPath: '/profile/passport'
      preLoaderRoute: typeof AppProfilePassportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/reviews': {
      id: '/_app/profile/reviews'
      path: '/profile/reviews'
      fullPath: '/profile/reviews'
      preLoaderRoute: typeof AppProfileReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/segments/$segmentId': {
      id: '/_app/segments/$segmentId'
      path: '/segments/$segmentId'
      fullPath: '/segments/$segmentId'
      preLoaderRoute: typeof AppSegmentsSegmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trips/': {
      id: '/_app/trips/'
      path: '/trips'
      fullPath: '/trips/'
      preLoaderRoute: typeof AppTripsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trips/$tripId': {
      id: '/_app/trips/$tripId'
      path: '/trips/$tripId'
      fullPath: '/trips/$tripId'
      preLoaderRoute: typeof AppTripsTripIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/explore/cities/$slug': {
      id: '/_app/explore/cities/$slug'
      path: '/explore/cities/$slug'
      fullPath: '/explore/cities/$slug'
      preLoaderRoute: typeof AppExploreCitiesSlugRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAddTicketRoute: typeof AppAddTicketRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppPlanRoute: typeof AppPlanRoute
  AppSearchRoute: typeof AppSearchRoute
  AppTicketsRoute: typeof AppTicketsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPlacesIdOrSlugRoute: typeof AppPlacesIdOrSlugRoute
  AppProfileNotificationsRoute: typeof AppProfileNotificationsRoute
  AppProfilePassportRoute: typeof AppProfilePassportRoute
  AppProfileReviewsRoute: typeof AppProfileReviewsRoute
  AppSegmentsSegmentIdRoute: typeof AppSegmentsSegmentIdRoute
  AppTripsTripIdRoute: typeof AppTripsTripIdRoute
  AppExploreIndexRoute: typeof AppExploreIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppTripsIndexRoute: typeof AppTripsIndexRoute
  AppExploreCitiesSlugRoute: typeof AppExploreCitiesSlugRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAddTicketRoute: AppAddTicketRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppPlanRoute: AppPlanRoute,
  AppSearchRoute: AppSearchRoute,
  AppTicketsRoute: AppTicketsRoute,
  AppIndexRoute: AppIndexRoute,
  AppPlacesIdOrSlugRoute: AppPlacesIdOrSlugRoute,
  AppProfileNotificationsRoute: AppProfileNotificationsRoute,
  AppProfilePassportRoute: AppProfilePassportRoute,
  AppProfileReviewsRoute: AppProfileReviewsRoute,
  AppSegmentsSegmentIdRoute: AppSegmentsSegmentIdRoute,
  AppTripsTripIdRoute: AppTripsTripIdRoute,
  AppExploreIndexRoute: AppExploreIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppTripsIndexRoute: AppTripsIndexRoute,
  AppExploreCitiesSlugRoute: AppExploreCitiesSlugRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  AuthOtpRoute: AuthOtpRoute,
  AuthPhoneRoute: AuthPhoneRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
